export default __webpack_public_path__ + "static/media/x.dbc01364.svg";